import React from "react";
import { Link } from "react-router-dom";
import FAQ from "./FAQ";
import GetAppHome from "./GetAppHome";
import Localities from "./Localities";
import OptionHero from "./OptionHero";

const HeroSection = () => {
  const citiesData = [
    {
      cName: "Chohla Sahib",
    },
    {
      cName: "Sarhali Kalan",
    },
    {
      cName: "Tarn Taran",
    },
    {
      cName: "Amritsar",
    },
    {
      cName: "Sohawa",
    },
  ];

  return (
    <div>
      <div
        className="container-fluid heroSection"
        style={{ paddingTop: "6.5rem", paddingBottom: "6.5rem" }}
      >
        <div className="row container m-auto" style={{ height: "23vh" }}>
          <h1
            className="text-center text-white"
            style={{ fontStyle: "italic", fontSize: "5rem", fontWeight: "900" }}
          >
            zomato
          </h1>

          <h1 className="text-white text-center fw-light">
            Discover the best food & drinks in{" "}
            <span className="fw-bold">Tarn Taran</span>
          </h1>

          <form class="d-flex justify-content-center mt-2" role="search">
            <input
              class="form-control"
              type="search"
              placeholder="Search"
              aria-label="Search"
              style={{
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                width: "44%",
              }}
            />

            <div class="dropdown">
              <button
                class="btn btn-light dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                  padding: "18px 23px",
                }}
              >
                Select Area
              </button>
              <ul class="dropdown-menu">
                {citiesData.map((data) => {
                  return (
                    <Link to={"/restaurant"} style={{ textDecoration: "none" }}>
                      <li>
                        <a class="dropdown-item" href="#">
                          {data.cName}
                        </a>
                      </li>
                    </Link>
                  );
                })}
              </ul>
            </div>
          </form>
        </div>
      </div>
      <OptionHero />
      <Localities />
      <GetAppHome />
      <FAQ />
    </div>
  );
};

export default HeroSection;
